import { get, set, del } from 'idb-keyval';
import type {
  PersistedClient,
  Persister,
} from '@tanstack/react-query-persist-client';

const DEFAULT_IDB_KEY = 'socnaQueries';

/**
 * Creates an Indexed DB persister
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
export const createIDBPersister = (
  idbValidKey: IDBValidKey = DEFAULT_IDB_KEY,
): Persister => ({
  persistClient: async (client: PersistedClient) => set(idbValidKey, client),
  restoreClient: async () => get<PersistedClient>(idbValidKey),
  removeClient: async () => del(idbValidKey),
});
